export const mobileMenu = (() => {
$('#mobile-menu').on('click', function(){
    $(this).find('.hamburger__inner').toggleClass('open');
    $('#sidebar-menu').toggleClass('sidebar__visible-mobile');
});

})();



// WEBPACK FOOTER //
// ./src/components/mobile-menu/mobile-menu.js